import { match, P } from 'ts-pattern';

import type { ContestEntitySourceV2 } from '~/services/contests/contests-v2.service.api';
import type { ContestSource } from '~/domains/contest/domains/services/enums/contest-source.enum';

import { getIsEOContest } from './getIsEOContest';

export const SPLASH_V2_ENTITY_SOURCE = 'splash_v2';

export type ContestNavigationTarget =
  | { kind: 'eo'; url: string; brand?: string }
  | { kind: 'splashV2'; url: string }
  | { kind: 'internal' }
  | { kind: 'none' };

type NavigableContest = {
  source?: ContestSource;
  entitySource?: ContestEntitySourceV2;
  game_center_url?: string | null;
  share_url?: string | null;
};

export const getContestNavigationTarget = (
  contest: NavigableContest
): ContestNavigationTarget => {
  const source = contest.entitySource ?? contest.source;
  // Navigation follows the BE-provided game-center URL only. No fallback: if the BE
  // doesn't provide it, the contest is not linkable (share_url is a deep link, not a
  // game center, and must not be used as a destination).
  const url = contest.game_center_url || null;

  return match({
    isEO: getIsEOContest(source),
    isSplashV2: source === SPLASH_V2_ENTITY_SOURCE,
    url,
  })
    .with(
      { isEO: true, url: P.string },
      ({ url: eoUrl }): ContestNavigationTarget => ({ kind: 'eo', url: eoUrl, brand: source })
    )
    .with(
      { isSplashV2: true, url: P.string },
      ({ url: v2Url }): ContestNavigationTarget => ({ kind: 'splashV2', url: v2Url })
    )
    .with(
      { isEO: true },
      { isSplashV2: true },
      (): ContestNavigationTarget => ({ kind: 'none' })
    )
    .otherwise((): ContestNavigationTarget => ({ kind: 'internal' }));
};
